<template>
<TitleComponent />
<LoopText />

<div class="max-w-7xl mx-auto grid grid-cols-1 sm:grid-cols-3 gap-16 py-24">
  <!-- Épilation -->
  <div class="flex flex-col items-center">
    <div class="bg-[#cd825b] rounded-full p-8 flex items-center justify-center mb-8">
      <img alt="Icône représentant une cire d'épilation" class="w-16 h-16 filter invert" src="../assets/svg/004-nail.svg" />
    </div>
    <h2 class="text-[#1B1F4D] text-xl leading-7 mb-4">
      Épilation professionnelle
    </h2>
    <p class="text-gray-600 text-base leading-7 max-w-xs mx-auto mb-8">
      Méthodes douces et efficaces pour une peau lisse et soyeuse, adaptée à chaque type de peau.
    </p>
    <a class="group relative inline-flex items-center justify-center text-[#1B1F4D] text-2xl leading-none" href="#" style="width: 2rem;">
      <span class="absolute left-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-base select-none -translate-x-6">
        voir plus
      </span>
      <span class="transform transition-transform duration-300 group-hover:translate-x-6">
        →
      </span>
    </a>
  </div>

  <!-- Beauté du regard -->
  <div class="flex flex-col items-center">
    <div class="bg-[#cd825b] rounded-full p-8 flex items-center justify-center mb-8">
      <img alt="Icône pour la beauté du regard" class="w-16 h-16 filter invert" src="../assets/svg/049-eye.svg" />
    </div>
    <h2 class="text-[#1B1F4D] text-xl leading-7 mb-4">
      Beauté du regard
    </h2>
    <p class="text-gray-600 text-base leading-7 max-w-xs mx-auto mb-8">
      Rehaussement, teinture et soin des cils et sourcils pour sublimer naturellement votre regard.
    </p>
    <a class="group relative inline-flex items-center justify-center text-[#1B1F4D] text-2xl leading-none" href="#" style="width: 2rem;">
      <span class="absolute left-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-base select-none -translate-x-6">
        voir plus
      </span>
      <span class="transform transition-transform duration-300 group-hover:translate-x-6">
        →
      </span>
    </a>
  </div>

  <!-- Soin & modelage -->
  <div class="flex flex-col items-center">
    <div class="bg-[#cd825b] rounded-full p-8 flex items-center justify-center mb-8">
      <img alt="Icône de soin du visage ou massage" class="w-16 h-16 filter invert" src="https://www.svgrepo.com/show/56152/massage-spa-body-treatment.svg" />
    </div>
    <h2 class="text-[#1B1F4D] text-xl leading-7 mb-4">
      Soins & Modelage
    </h2>
    <p class="text-gray-600 text-base leading-7 max-w-xs mx-auto mb-8">
      Détente et revitalisation grâce à nos soins du visage et massages sur-mesure.
    </p>
    <a class="group relative inline-flex items-center justify-center text-[#1B1F4D] text-2xl leading-none" href="#" style="width: 2rem;">
      <span class="absolute left-0 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-base select-none -translate-x-6">
        voir plus
      </span>
      <span class="transform transition-transform duration-300 group-hover:translate-x-6">
        →
      </span>
    </a>
  </div>
</div>





<div class="max-w-[1800px] mx-auto flex flex-col lg:flex-row items-center lg:items-start min-h-screen">
  <div class="w-full lg:w-1/2 flex justify-center lg:justify-start">
    <img
      alt="Femme souriante tenant un pinceau de maquillage avec un fond bleu clair"
      class="w-full max-w-[720px] max-h-[600px] object-cover"
      height="1080"
      src="https://img.freepik.com/free-photo/flat-lay-gua-sha-care-products-arrangement_23-2149322586.jpg?t=st=1744971503~exp=1744975103~hmac=1ae8ed765b0b89926bb34e056dcc3b63ee933128f6fb66692dbadf56f0ddfad2&w=826"
      width="720"
    />
  </div>
  <div class="w-full lg:w-1/2 px-6 lg:px-20 py-12 lg:py-24 flex flex-col justify-start">
    <span class="text-red-700 text-xs tracking-widest mb-2">
      SOINS NATURELS
    </span>
    <h1 class="text-[2.5rem] leading-[1.1] text-[#0a1a4f] font-normal max-w-[600px] mb-6">
      Bien-être et beauté au naturel, au cœur de Taverny.
    </h1>
    <p class="text-gray-500 max-w-[600px] mb-6 text-base font-sans">
      Naturo-esthéticienne, je vous offre des soins respectueux de votre corps et de l'environnement. Offrez-vous une pause bien-être avec des massages et des soins sur mesure.
    </p>
    <p class="text-gray-500 max-w-[600px] mb-6 text-base font-sans">
      Découvrez le massage aux ventouses froides, une technique ancestrale pour libérer les tensions et rééquilibrer votre énergie.
    </p>
    <p class="text-gray-500 max-w-[600px] mb-20 text-base font-sans">
      Le diagnostic VisioDerm est offert avec l'achat de deux produits cosmétiques. Un soin sur mesure pour chaque type de peau.
    </p>
    <div class="relative max-w-[600px]">
      <img
        alt="Pot ouvert de crème avec couvercle en bois et feuilles vertes sur fond beige avec lignes courbes"
        class="w-full object-cover"
        height="400"
        src="https://img.freepik.com/free-photo/beautiful-young-girl-beauty-salon_1157-21119.jpg?t=st=1744971555~exp=1744975155~hmac=0a34724728da928bdbbebfe9e34d2ec4787e5e2079a181043e701ab773e268e1&w=2000"
        width="600"
      />
    </div>
  </div>
</div>

<div class="relative w-full h-[45vh] overflow-hidden">
   <img alt="Smiling woman with light brown hair holding a capsule and a section of her hair in one hand, beige background" class="w-full h-full object-cover filter brightness-50" height="1080" src="https://storage.googleapis.com/a1aa/image/ba8884dd-efba-48bc-76dc-512baf994057.jpg" width="1920"/>
   <div class="absolute inset-0 flex flex-col items-center justify-center text-center px-4" style="color: white;">
    <p class="text-xs tracking-widest mb-2 font-semibold" style="color: #ffffffcc;">
     LA NATURE A TANT À NOUS OFFRIR
    </p>
    <h1 class="text-white font-serif text-2xl sm:text-5xl md:text-4xl max-w-4xl leading-tight" style="font-family: 'Playfair Display', serif;">
     Pourquoi chercher ailleurs ?<br class="hidden sm:block"/>
     Des soins visage 100% naturels et BIO Phyts.<br class="hidden sm:block"/>
     Adoptez une routine bio pour votre peau.
    </h1>
    <button class="mt-8 bg-[#b82216] text-white font-serif text-lg px-8 py-3 hover:bg-[#a31d13] transition-colors" style="font-family: 'Playfair Display', serif;">
     Voir plus
    </button>
   </div>
</div>





</template>

<script>
import TitleComponent from '@/components/TitleComponent.vue';
import LoopText from '@/components/LoopText.vue';
export default {
  components: { TitleComponent , LoopText },
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;700&family=Roboto:wght@400;500&display=swap');
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/5.15.3/css/all.min.css');

.font-roboto {
  font-family: 'Roboto', sans-serif;
}
.title {
  font-family: 'Playfair Display', serif;
}
.menu-toggle {
  transition: transform 0.3s ease-in-out;
}
.menu-toggle.open i {
  transform: rotate(90deg);
}
</style>
